export default ({ request }) => ({
  materialInspectionDefectList(data = {}) {
    return request({
      url: '/factory/material/inspection/defect/list',
      method: 'post',
      data
    })
  },
  materialInspectionDefectAdd(data = {}) {
    return request({
      url: '/factory/material/inspection/defect/add',
      method: 'post',
      data
    })
  },
  materialInspectionDefectDel(data = {}) {
    return request({
      url: '/factory/material/inspection/defect/del',
      method: 'post',
      data
    })
  },
  materialInspectionDefectSubtract(data = {}) {
    return request({
      url: '/factory/material/inspection/defect/subtract',
      method: 'post',
      data
    })
  }
})
